import React, { useEffect, useState } from "react";
import {
  Form,
  Modal,
  Input,
  InputNumber,
  Typography,
  Table,
  Button,
  Select,
  message,
} from "antd";
import { platformApi } from "../../../../../../api";
const { Text } = Typography;
const { Option } = Select;
const ImagesModal = ({ form, open, close, emitData, initialData = [] }) => {
  // Main table data
  const [tableData, setTableData] = useState([]);
  // State for dropdown suggestions
  const [dropDownList, setDropDownList] = useState([]);
  // Counter for unique IDs of newly added items
  const [counter, setCounter] = useState(0);
  // Row selection
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // Initialize with existing data when modal opens
  useEffect(() => {
    if (open) {
      // Reset newly added items when modal opens
      // setNewlyAdded(new Set()); // This line is removed

      if (initialData.length > 0) {
        const formattedData = initialData.map((item) => ({
          ...item,
          id: item.id.toString(),
          isPercent: item.isPercent || false,
          discount: item.discount || 0,
          mrp: item.mrp || 0,
          quantity: item.quantity || 1,
        }));
        setTableData(formattedData);
        setSelectedRowKeys(formattedData.map((item) => item.id));
        // Set form values for discounts
        formattedData.forEach((item) => {
          form.setFieldsValue({
            [`discount_${item.id}`]: item.discount,
          });
        });
      } else {
        // Reset when opening with no initial data
        setTableData([]);
        setSelectedRowKeys([]);
        form.resetFields();
      }
    }
  }, [open, initialData]);
  let debounceTimer;
  const handleSearch = async (value) => {
    if (value) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => {
        try {
          // Using the same (first) API call for "Accessories":
          // /api/partsMaster/accessories?category=Accessories&searchString=${value}
          const response = await platformApi.get(
            `/api/partsMaster/accessories?searchString=${value}`
          );
          const { data } = response;
          if (data && data.response && data.response.data) {
            // Filter out items already in tableData
            const existingIds = tableData.map((item) => item.id.toString());
            const filteredData = data.response.data.filter(
              (item) => !existingIds.includes(item.id.toString())
            );
            setDropDownList(filteredData);
          } else {
            setDropDownList([]);
          }
        } catch (error) {
          console.log(error);
          setDropDownList([]);
          message.error("Failed to search accessories.");
        }
      }, 500);
    }
  };
  // Update specific field in tableData
  const updateRowField = (id, field, value) => {
    const updatedData = tableData.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setTableData(updatedData);
  };
  const deleteRow = (id, row) => {
    if (!row.new) {
      platformApi.delete(`/api/booking/accessory/${row.arrayId}`).then(() => { }).catch((err) => {
        console.error("Error deleting accessory:", err)
      })
    }
    setTableData(tableData.filter((row) => row.id !== id));
  };
  const handleSelect = (value, row) => {
    updateRowField(row.id, "isPercent", value === "percent");
  };
  const handleModelSelect = (selectedValues) => {
    // We only need to add the last selected item
    const lastSelectedId = selectedValues[selectedValues.length - 1];
    const selectedModel = dropDownList.find(
      (model) => model.id === lastSelectedId
    );
    if (selectedModel) {
      setCounter(counter + 1);
      const newRow = {
        ...selectedModel,
        id: `${selectedModel.id}`,
        isPercent: false,
        discount: selectedModel.discount || 0,
        mrp: selectedModel.mrp || 0,
        quantity: 1,
        new: true
      };

      // Add to newly added items set // This line is removed
      // setNewlyAdded((prev) => new Set([...prev, newRow.id])); // This line is removed
      setTableData([...tableData, newRow]);
      // Automatically select the newly added row
      setSelectedRowKeys([...selectedRowKeys, newRow.id]);

      // Remove the selected item from dropdown list
      setDropDownList(
        dropDownList.filter((item) => item.id !== lastSelectedId)
      );
    }
    handleSearch("");
  };
  const handleSubmit = () => {
    const selectedNewRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    const prefilledRows = tableData.filter(
      (row) => !selectedRowKeys.includes(row.id)
    );

    const allRows = [...selectedNewRows, ...prefilledRows];

    const formattedRows = allRows.map((row) => ({
      ...row,
      quantity: row.quantity || 1,
      isPercent: row.isPercent || false,
      discount: row.discount || 0,
      mrp: row.mrp || 0,
    }));
    emitData(formattedRows);
    close();
    form.resetFields();
    setTableData([]);
    setSelectedRowKeys([]);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
    getCheckboxProps: (record) => ({
      disabled: false,
    }),
  };
  // Table columns
  const columns = [
    {
      title: "Accessory Name",
      dataIndex: "partName",
      key: "partName",
      render: (text, row) => (
        <Input
          value={text}
          disabled={true}
          onChange={(e) => updateRowField(row.id, "partName", e.target.value)}
        />
      ),
    },
    {
      title: "Accessory Code",
      dataIndex: "partNumber",
      key: "partNumber",
      render: (text, row) => (
        <Input
          value={text}
          disabled={true}
          onChange={(e) => updateRowField(row.id, "partNumber", e.target.value)}
        />
      ),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (text, row) => {
        const fieldKey = `discount_${row.id}`;
        const discountTypeSelect = (
          <Select
            value={row.isPercent ? "percent" : "amount"}
            className="discount-select-addon"
            onChange={(value) => handleSelect(value, row)}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            <Option value="amount">₹</Option>
            <Option value="percent">%</Option>
          </Select>
        );
        return (
          <Form.Item style={{ marginBottom: 0 }}>
            {form.getFieldDecorator(fieldKey, {
              initialValue: Number(row.discount) === 0 ? '' : row.discount,
              normalize: (val) => {
                if (typeof val === 'string') {
                  let cleaned = val.replace(/[^\d.]/g, '');
                  const parts = cleaned.split('.');
                  if (parts.length > 2) {
                    cleaned = parts[0] + '.' + parts.slice(1).join('');
                  }
                  return cleaned.replace(/^0+(?=\d)/, '');
                }
                return val;
              }
            })(
              <Input
                addonAfter={discountTypeSelect}
                disabled={false}
                onKeyDown={(e) => {
                  if (['-', '+', 'e', 'E'].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  let rawValue = e.target.value;
                  if (typeof rawValue === 'string') {
                    rawValue = rawValue.replace(/[^\d.]/g, '');
                    const parts = rawValue.split('.');
                    if (parts.length > 2) {
                      rawValue = parts[0] + '.' + parts.slice(1).join('');
                    }
                    rawValue = rawValue.replace(/^0+(?=\d)/, '');
                  }
                  const value = rawValue === '' ? 0 : parseFloat(rawValue) || 0;
                  updateRowField(row.id, "discount", value);
                }}
                onWheel={(event) => event.currentTarget.blur()}
                placeholder="Discount"
                type="text"
                inputMode="numeric"
              />
            )}
          </Form.Item>
        );
      },
    },
    {
      title: "Before Discount",
      dataIndex: "mrp",
      key: "mrp",
      render: (text, row) => (
        <Input
          value={row.mrp}
          disabled={true}
          onChange={(e) => {
            const newValue = parseFloat(e.target.value) || 0;
            updateRowField(row.id, "mrp", newValue);
          }}
        />
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, row) => (
        <InputNumber
          min={1}
          value={row.quantity}
          style={{ width: "100%" }}
          onChange={(value) => {
            const newValue = parseInt(value) || 1;
            updateRowField(row.id, "quantity", newValue);
          }}
        />
      ),
    },
    {
      title: "After Discount",
      dataIndex: "afterDiscount",
      key: "afterDiscount",
      render: (_, row) => {
        const discount = row.discount || 0;
        const quantity = row.quantity || 1;
        const perUnitPrice = row.isPercent
          ? row.mrp - (row.mrp * discount) / 100
          : row.mrp - discount;
        const totalPrice = perUnitPrice * quantity;
        return (
          <span style={{ fontWeight: "500" }}>
            {row.discount
              ? totalPrice.toFixed(2)
              : (row.mrp * quantity).toFixed(2)}
          </span>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, row) => (
        <Button type="danger" onClick={() => deleteRow(row.id, row)}>
          Delete
        </Button>
      ),
    },
  ];
  // Calculate total amount for all selected items
  const calculateTotal = () => {
    return tableData
      .filter((row) => selectedRowKeys.includes(row.id))
      .reduce((total, row) => {
        const quantity = row.quantity || 1;
        const price = row.mrp || 0;
        const discount = row.discount || 0;
        const afterDiscount = row.isPercent
          ? price - (price * discount) / 100
          : price - discount;
        return total + afterDiscount * quantity;
      }, 0);
  };
  return (
    <Modal
      title={<Text strong>Accessories Table</Text>}
      visible={open}
      onCancel={() => {
        close();
        setTableData([]);
        setSelectedRowKeys([]);
        form.resetFields();
      }}
      onOk={handleSubmit}
      width="75vw"
      okText="Save"
    >
      <style dangerouslySetInnerHTML={{ __html: `
        .discount-select-addon {
          width: 65px !important;
          height: 100% !important;
        }
        .discount-select-addon .ant-select-selection {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          height: 100% !important;
          display: flex !important;
          align-items: center !important;
          overflow: hidden !important;
          padding: 0 !important;
        }
        .discount-select-addon .ant-select-selection__rendered {
          margin-left: 12px !important;
          margin-right: 20px !important;
          line-height: normal !important;
        }
        .discount-select-addon .ant-select-arrow {
          right: 8px !important;
        }
      `}} />
      <div style={{ marginBottom: 16 }}>
        <Select
          mode="multiple"
          showSearch
          placeholder="Select Accessories"
          style={{ width: "100%" }}
          allowClear
          onSearch={handleSearch}
          filterOption={false}
          onChange={handleModelSelect}
          value={[]}
        >
          {dropDownList.map((model) => (
            <Option key={model.id} value={model.id}>
              {model.partName} - {model.partNumber}
            </Option>
          ))}
        </Select>
      </div>
      <Form>
        <Table
          rowSelection={rowSelection}
          rowKey="id"
          columns={columns}
          dataSource={tableData}
          pagination={{ pageSize: 5 }}
          tableLayout="fixed"
        />
      </Form>
    </Modal>
  );
};
const AccessoryModal = Form.create({ name: "imagesModal" })(ImagesModal);
export default AccessoryModal;

